import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import profileImage from "../../../../../../media/images/profileImage.png";
import { Link } from "react-router-dom";
import ArrowLeftSVG from "../../../../../../media/images/icons/arrow-left";

export default function Header() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        marginX: "8px",
        borderColor: "secondary.dark",
        backgroundColor: "secondary.light",
        display: "flex",
        border: "1px solid gray",
        alignItems: "center",
        padding: "8px",
        gap: "8px",
        borderRadius: "16px",
      }}
    >
      <img
        style={{
          width: 45,
          height: 45,
          borderRadius: "50%",
        }}
        src={profileImage}
        alt=""
      />
      <Box
        sx={{
          flex: "1",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            رضا عزیز،{" "}
          </Typography>
          <Typography sx={{ fontWeight: "600" }}>
            اینجا می‌تونی آموزش ببینی و امتیاز بگیری.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography>امتیاز</Typography>
            <Typography
              sx={{
                fontWeight: "600",
              }}
            >
              456
            </Typography>
          </Box>
          <Link
            to={"#"}
            style={{
              backgroundColor: theme.palette.secondary.main,
              padding: "6px",
              borderRadius: "6px",
              //   border: "1px solid gray",
              display: "flex",
              gap: "3px",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
              }}
            >
              امتیازها
            </Typography>
            <ArrowLeftSVG size={20} />
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
